import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { map } from 'rxjs/operators';
import {
  State,
  getIntegrationAction,
  getIsIntegrationLoading,
  getIntegration,
} from '../../store';

@Component({
  selector: 'integrations-main',
  templateUrl: './integrations.component.html',
  styleUrls: ['./integrations.component.scss'],
})
export class IntegrationsComponent implements OnInit {
  constructor(
    private readonly store: Store<State>,
    private readonly route: ActivatedRoute,
  ) {}
  isLoading$ = this.store.pipe(select(getIsIntegrationLoading));
  integration$ = this.store.pipe(select(getIntegration));
  id$ = this.route.params.pipe(map((params) => params.id as string));

  private get id() {
    return this.route.snapshot.params.id;
  }

  ngOnInit() {
    this.store.dispatch(getIntegrationAction({ id: this.id }));
  }
}
